package se.mittpass.web.components

import se.mittpass.web.*
import se.mittpass.web.components.*
import se.mittpass.web.pages.*
import se.mittpass.web.viewmodel.*
import se.mittpass.web.style.*


import androidx.compose.runtime.*
import org.jetbrains.compose.web.dom.*
import se.mittpass.shared.api.AttendanceDto

@Composable
internal fun PliggarYearView(
    year: Int,
    records: List<AttendanceDto>,
    isMobile: Boolean,
    isNarrow: Boolean,
    onDayClick: (day: String) -> Unit
) {
    val countByDay = remember(records) {
        records.groupingBy { it.checkInTime.substringBefore("T") }.eachCount()
    }
    val today = todayLocalDate()

    val cols = when {
        isMobile -> 1
        isNarrow -> 2
        else -> 4
    }

    Div({
        style {
            property("display", "grid")
            property("grid-template-columns", "repeat($cols, 1fr)")
            property("gap", if (isMobile) "1rem" else "1.5rem")
        }
    }) {
        for (m in 1..12) {
            PliggarMiniMonth(year, m, countByDay, today, onDayClick)
        }
    }
}

@Composable
private fun PliggarMiniMonth(
    year: Int,
    month: Int,
    countByDay: Map<String, Int>,
    today: String,
    onDayClick: (String) -> Unit
) {
    val first = "$year-${month.toString().padStart(2, '0')}-01"
    val gridStart = mondayOf(first)

    Div({
        style {
            property("display", "flex"); property("flex-direction", "column"); property("gap", "0.5rem")
        }
    }) {
        Span({ style {
            property("font-weight", "700"); property("font-size", "0.95rem"); property("color", "var(--rp-text)")
            property("letter-spacing", "-0.2px")
        } }) { Text(MONTH_NAMES[month - 1].replaceFirstChar { it.uppercase() }) }

        Div({ style {
            property("display", "grid")
            property("grid-template-columns", "repeat(7, 1fr)")
            property("gap", "2px")
        } }) {
            for (i in 0..6) {
                Div({ style {
                    property("text-align", "center"); property("font-size", "0.6rem")
                    property("font-weight", "700"); property("color", "var(--rp-muted)")
                    property("padding", "0.15rem 0")
                } }) { Text(DAY_NAMES_SHORT[i].take(1)) }
            }

            for (idx in 0 until 42) {
                val cellDate = addDays(gridStart, idx)
                val parts = cellDate.split("-")
                val cellMonth = parts[1].toInt()
                val dayNum = parts[2].toInt()
                val isOtherMonth = cellMonth != month
                val isToday = cellDate == today
                val count = countByDay[cellDate] ?: 0
                val intensity = when {
                    count == 0 -> 0
                    count <= 2 -> 1
                    count <= 5 -> 2
                    else -> 3
                }
                val bg = when {
                    isOtherMonth -> "transparent"
                    intensity == 0 -> "var(--rp-overlay)"
                    intensity == 1 -> "var(--rp-info-border)"
                    intensity == 2 -> "var(--rp-muted)"
                    else -> "var(--rp-pine)"
                }
                val color = when {
                    isOtherMonth -> "var(--rp-hl-med)"
                    intensity >= 2 -> "var(--rp-surface)"
                    else -> "var(--rp-subtle)"
                }
                Div({
                    onClick { if (!isOtherMonth) onDayClick(cellDate) }
                    attr("title", if (count > 0) "$cellDate: $count person(er)" else cellDate)
                    style {
                        property("aspect-ratio", "1 / 1")
                        property("display", "flex"); property("align-items", "center"); property("justify-content", "center")
                        property("font-size", "0.62rem"); property("font-weight", "600")
                        property("border-radius", "5px")
                        property("background", bg); property("color", color)
                        if (!isOtherMonth) property("cursor", "pointer")
                        if (isToday) {
                            property("outline", "2px solid var(--rp-pine)")
                            property("outline-offset", "-1px")
                        }
                    }
                }) { Text(if (isOtherMonth) "" else dayNum.toString()) }
            }
        }
    }
}
